/* eslint-disable import/prefer-default-export */

export const standardEventorFeatures = [{
  iconClassNames: ['fas', 'file-excel'],
  label: 'Excel file import',
}, {
  iconClassNames: ['fas', 'qrcode'],
  label: 'QR Code check-in',
}, {
  iconClassNames: ['fas', 'comment-alt-check'],
  label: 'VIP push notifications',
}, {
  iconClassNames: ['fas', 'user-friends'],
  label: 'Teams support & shared events',
}, {
  iconClassNames: ['fas', 'portrait'],
  label: 'Guest pictures',
}, {
  iconClassNames: ['fas', 'life-ring'],
  label: 'Dedicated support',
}];
